/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 * See the LICENSE file for the full text.
 */

/**
 * The course as it is stored in `event_activity_route.route_polyline` (jsonb).
 *
 * Written as a GeoJSON LineString — `[lng, lat]` order, as GeoJSON requires —
 * because it is the one format that is self-describing in a jsonb column and
 * that geoLine.js (what the public event page reads it with) already accepts.
 * Read back through that same parser, so the form and the public page can never
 * disagree about what a stored value means.
 */

import parseLine from '../event-detail/geoLine';

export function toLineString(points) {
  if (!Array.isArray(points) || points.length < 2) return null;
  return {
    type: 'LineString',
    // Exact, not rounded: the stored line must hold the same coordinates as the
    // GPX file attached with it (see buildGpx `coord`).
    coordinates: points.map((p) => [Number(p.lng), Number(p.lat)]),
  };
}

/** Whatever `route_polyline` holds, as `[{lat, lng}]` — or [] when there is no usable line. */
export function fromStoredLine(value) {
  // parseLine also accepts the JSON text some endpoints return a jsonb value as.
  return parseLine(value) || [];
}
